// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3rJiI","title":"ClientInsurance_title__3aDkZ","itemText":"ClientInsurance_itemText__2Sc-9"};